export const useMobileMenu = {
    computed: {
        useMobileMenu() {
            return !this.$vuetify.breakpoint.lgAndUp;
        }
    }
}